import type { CSSProperties } from 'react';

import { theme } from '@/style/theme';

/** Ported from packages/desktop-client/src/components/budget/util.ts */

export function makeAmountGrey(value: number | string | null): CSSProperties {
  return {
    color:
      value === 0 || value === '0' || value === null
        ? theme.tableTextInactive
        : undefined,
  };
}

export function makeBalanceAmountStyle(
  value: number | null | undefined,
): CSSProperties {
  if (value === 0) return { color: theme.budgetNumberZero, fontWeight: 500 };
  if (value !== null && value !== undefined && value < 0) {
    return { color: theme.numberNegative, fontWeight: 500 };
  }
  return { fontWeight: 500 };
}

/** Tabular figures with open digits, as upstream applies to every money cell. */
export const tnum: CSSProperties = {
  fontFeatureSettings: '"tnum", "ss01", "ss04"',
};
